import React, {Component} from 'react';
import { Formik, Form, Field } from 'formik';
import {
    Grid,
    Button,
    Message,
    Divider,
    Header,
} from 'semantic-ui-react';

import FormsInputsEmail from '../../inputs/email/forms_inputs_email';
import FormsInputsText from '../../inputs/text/forms_inputs_text';
import FormsInputsNumber from '../../inputs/number/forms_inputs_number';
import UpdateContactNumberSchema from './validation';
import UpdateProfileSchema from '../../profile/update_profile/validation';
import FormsInputsDropdownAddition from '../../inputs/dropdownaddition';
import _ from 'underscore';

// options={prepareDynamicDropDownSelectionCountryCodeWithAddition(values.newContactNoCountryCode1, this.props.countryCodeOptions, false, true)}
const prepareDynamicDropDownSelectionCountryCodeWithAddition = (selectedValue, list, useValueAsText = false, useTextAsValue = false) => {
    var object = _.find(list, (item) => { return item.n === selectedValue })
    var _list = list
    if (object === undefined) {
        _list.push({'n': selectedValue})
    }
    var sorted = _.sortBy(_list, 'n');
    return _.map(sorted, (item) => {
        return { text: (useValueAsText === false) ? item.n : item.c , value: (useTextAsValue === false) ? item.c : item.n };
    })
}

const prepareCountryCodeOptions = (list) => {
    return _.map(list, (item) => {
        return { text: `${item.code} (${item.label})`, value: item.code };
    })
}

class FormsUpdateContactNumber extends Component {
    state = {
        error: false,
        errorMessage: null,
        success: false,
        contactNo: '',
    }

    componentWillMount() {
        const _contactNo = this.props.user.contactNoCountryCode + this.props.user.contactNo
        this.setState({
            contactNo: _contactNo
        })
    }

    renderVerifyOTPForm() {
        if (this.state.success === true) {
            return (
                <Grid.Column>
                    <Field
                        name="otp"
                        label="OTP"
                        component={FormsInputsText}
                        secondaryLabel=""
                    />
                </Grid.Column>
            );
        }
    }

    renderFormSubmissionResult() {
        if (this.state.error === true) {
            return (
                <Message negative>
                    <Message.Header>We're sorry - there was an issue with the change</Message.Header>
                    <p>
                        { this.state.errorMessage }
                    </p>
                </Message>
            );
        }

        if (this.state.success === true) {
            return (
                <Message positive>
                    <Message.Header>Your mobile number is successfully changed!</Message.Header>
                </Message>
            );
        }
    }

    render() {
        const _contactNo = this.state.contactNo
        const countryCodeOptions = prepareCountryCodeOptions(this.props.countryCodeOptions);
        return (
            <div>
                <Formik
                    initialValues={{
                        currentContactNo: _contactNo,
                        newContactNoCountryCode1: '',
                        newContactNoCountryCode2: '',
                        newContactNo1: '',
                        newContactNo2: ''
                    }}
                    validateOnChange={true}
                    validateOnBlur={false}
                    validationSchema={UpdateContactNumberSchema}
                    validate={(values) => {
                        // Additional Validation (if any)
                        let error = {};
                        if (values.newContactNoCountryCode1 !== values.newContactNoCountryCode2) {
                            error.newContactNoCountryCode2 = 'The country codes do not match.'
                        }

                        if (values.newContactNo1 !== values.newContactNo2) {
                            error.newContactNo2 = 'The contact numbers do not match.'
                        }

                        if (values.newContactNo2 === this.props.user.contactNo) {
                            error.newContactNo2 = 'There is no change in your contact number.'
                        }

                        return error;
                    }}
                    onSubmit={(values, actions) => {
                        this.props.updateUserProfileInformation({data: {'contactNoCountryCode': values.newContactNoCountryCode1, 'contactNo': values.newContactNo1}, accessToken: this.props.user.accessToken}, (result, error) => {
                            console.log('done');
                            actions.setSubmitting(false);
                            if (error) {
                                console.log('done-failed');

                                this.setState({
                                    error: true,
                                    success: false,
                                    errorMessage: error.errorMessage
                                });
                            }
                            if (result) {
                                console.log('done-success');
                                this.setState({
                                    error: false,
                                    errorMessage: null,
                                    success: true,
                                    contactNo: values.newContactNoCountryCode1 + values.newContactNo1
                                });
                            }

                            actions.resetForm();
                        });
                    }}
                    render={({
                        values,
                        errors,
                        status,
                        touched,
                        handleBlur,
                        handleChange,
                        handleSubmit,
                        isSubmitting,
                    }) => (
                        <Form style={{paddingBottom: 20, paddingTop: 20}}>
                            <Grid columns={1}>
                                <Grid.Column>
                                    <Field
                                        name="currentContactNo"
                                        label="Old Contact Number"
                                        component={FormsInputsText}
                                        secondaryLabel=""
                                        disabled={true}
                                    />
                                </Grid.Column>
                            </Grid>

                            <Divider></Divider>
                            <Grid>
                                <Grid.Column>
                                    New Contact Number
                                </Grid.Column>
                            </Grid>
                            <Grid columns={2}>
                                <Grid.Column>
                                    <Field
                                        name="newContactNoCountryCode1"
                                        options={countryCodeOptions}
                                        label="Country Code"
                                        component={FormsInputsDropdownAddition}
                                        secondaryLabel=""
                                    />
                                </Grid.Column>
                                <Grid.Column >
                                    <Field
                                        name="newContactNo1"
                                        label="Contact Number"
                                        component={FormsInputsNumber}
                                        secondaryLabel=""
                                    />
                                </Grid.Column>
                            </Grid>

                            <Divider></Divider>
                            <Grid>
                                <Grid.Column>
                                    Re-enter New Contact Number
                                </Grid.Column>
                            </Grid>
                            <Grid columns={2}>
                                <Grid.Column>
                                    <Field
                                        name="newContactNoCountryCode2"
                                        label="Country Code"
                                        options={countryCodeOptions}
                                        component={FormsInputsDropdownAddition}
                                        secondaryLabel=""
                                    />
                                </Grid.Column>
                                <Grid.Column >
                                    <Field
                                        name="newContactNo2"
                                        label="Contact Number"
                                        component={FormsInputsNumber}
                                        secondaryLabel=""
                                    />
                                </Grid.Column>
                            </Grid>


                            <Grid columns={1}>
                                <Grid.Column width={16}>
                                    { this.renderFormSubmissionResult() }
                                </Grid.Column>

                                <Grid.Column width={16}>
                                    <Button
                                        loading={isSubmitting}
                                        type="submit"
                                        primary
                                        disabled={isSubmitting}
                                        fluid
                                        size="big"
                                    >
                                        Save
                                    </Button>
                                </Grid.Column>
                            </Grid>
                        </Form>
                    )}
                />
            </div>
        );
    }
}

export default FormsUpdateContactNumber;
